// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%236B7280%27 d=%27M2 4l4 4 4-4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_oceanCalendarWrapper__sqXp8 {
  padding: 0;
  background: #F9FAFB;
  height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.styles_oceanCalendarWrapper__sqXp8 .fc-scroller::-webkit-scrollbar {
  width: 8px;
}
.styles_oceanCalendarWrapper__sqXp8 .fc-scroller::-webkit-scrollbar-track {
  background: transparent;
}
.styles_oceanCalendarWrapper__sqXp8 .fc-scroller::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}
.styles_oceanCalendarWrapper__sqXp8 .fc-scroller::-webkit-scrollbar-button {
  display: none;
}
.styles_oceanCalendarWrapper__sqXp8::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #F9FAFB;
  z-index: -1;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_syncToolbarElement__O\\+Y94 {
  position: absolute;
  top: 25px;
  display: flex;
  align-items: center;
  z-index: 100;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_syncToolbarElement__O\\+Y94.styles_chatbotOpen__\\+oAm9 {
  right: 280px;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_syncToolbarElement__O\\+Y94.styles_chatbotClosed__2f\\+6C {
  right: 340px;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_inlineToolbarElements__cDCs- {
  position: absolute;
  top: 20px;
  right: 290px;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 100;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_navDropdownContainer__GG1bn {
  position: relative;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_navDropdownButton__BJdwe {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  font-size: 15px;
  font-weight: 500;
  color: #3B82F6;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background 0.2s;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_navDropdownButton__BJdwe:hover {
  background: #F3F4F6;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_navDropdownButton__BJdwe .styles_dropdownArrow__bfZ3F {
  width: 14px;
  height: 14px;
  transition: transform 0.2s ease;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_navDropdownButton__BJdwe .styles_dropdownArrow__bfZ3F.styles_open__5X1Ud {
  transform: rotate(180deg);
}
.styles_oceanCalendarWrapper__sqXp8 .styles_navDropdownMenu__U1h9q {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  z-index: 1000;
  overflow: hidden;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_navDropdownItem__hyycS {
  display: block;
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_navDropdownItem__hyycS:hover {
  background: #F3F4F6;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_navDropdownItem__hyycS.styles_active__xyHD0 {
  color: #3B82F6;
  font-weight: 500;
  background: #EFF6FF;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_chatbotToggle__xQPzy {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  transition: transform 0.2s ease;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_chatbotToggle__xQPzy img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_chatbotToggle__xQPzy:hover {
  transform: translateY(-2px);
}
.styles_oceanCalendarWrapper__sqXp8 .styles_calendarContainer__\\+eH4A {
  background: white;
  border-radius: 0;
  padding: 20px;
  box-shadow: none;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_calendarContainer__\\+eH4A.styles_isLoading__zEyNn .fc {
  opacity: 0.6;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_calendarContainer__\\+eH4A .fc {
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: opacity 0.3s ease;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_shimmerOverlay__yqqtb {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  overflow: hidden;
  pointer-events: none;
  border-radius: 12px;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_shimmer__GLFda {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80%, transparent 100%);
  animation: styles_shimmerAnimation__PRgc0 0.75s infinite;
}
@keyframes styles_shimmerAnimation__PRgc0 {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.styles_oceanCalendarWrapper__sqXp8 .styles_timezonePicker__Z061v {
  position: absolute;
  top: 140px;
  left: 22px;
  z-index: 100;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_timezoneButton__IO9KK {
  background: transparent;
  border: none;
  font-size: 12px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.15s ease;
}
.styles_oceanCalendarWrapper__sqXp8 .styles_timezoneButton__IO9KK:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.styles_timezoneDropdown__mpbMj {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 160px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
}

.styles_timezoneOption__Iu75U {
  display: block;
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  text-align: left;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.styles_timezoneOption__Iu75U:hover {
  background-color: #F3F4F6;
}
.styles_timezoneOption__Iu75U.styles_selected__R3WqA {
  background-color: #EFF6FF;
  color: #2563EB;
  font-weight: 500;
}

.fc {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}
.fc .fc-toolbar {
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}
.fc .fc-toolbar .fc-toolbar-title {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}
.fc .fc-toolbar .fc-button-group .fc-button {
  background: #FFFFFF;
  border: 1px solid #D1D5DB;
  color: #374151;
  padding: 6px 12px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s;
}
.fc .fc-toolbar .fc-button-group .fc-button:hover:not(:disabled) {
  background: #F3F4F6;
  border-color: #9CA3AF;
}
.fc .fc-toolbar .fc-button-group .fc-button:focus {
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}
.fc .fc-toolbar .fc-button-group .fc-button.fc-button-active {
  background: #3B82F6;
  color: white;
  border-color: #3B82F6;
}
.fc .fc-toolbar .fc-button-group .fc-button.fc-button-active:hover {
  background: #2563EB;
  border-color: #2563EB;
}
.fc .fc-toolbar .fc-button-group .fc-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.fc .fc-toolbar .fc-today-button {
  background: #3B82F6;
  color: white;
  border: none;
  padding: 6px 16px;
  font-weight: 500;
}
.fc .fc-toolbar .fc-today-button:hover:not(:disabled) {
  background: #2563EB;
}
.fc .fc-toolbar .fc-today-button:disabled {
  opacity: 0.5;
  background: #3B82F6;
}
.fc .fc-scrollgrid {
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  overflow: visible;
}
.fc .fc-scrollgrid td, .fc .fc-scrollgrid th {
  border-color: #E5E7EB !important;
}
.fc .fc-scrollgrid-section-header .fc-col-header-cell {
  background: #F9FAFB;
  padding: 10px 8px;
  font-weight: 600;
  color: #374151;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: visible;
}
.fc .fc-timegrid-divider {
  border-color: transparent !important;
  position: relative;
}
.fc .fc-timegrid-divider::after {
  content: "";
  position: absolute;
  left: 0;
  right: 75% !important;
  top: 0;
  height: 100%;
  border-top: 1px solid #E5E7EB;
}
.fc .fc-timegrid-now-indicator-arrow {
  display: none;
}
.fc .fc-timegrid-now-indicator-line {
  border-color: #EF4444;
  border-width: 1px;
  position: relative;
  z-index: 100;
}
.fc .fc-timegrid-now-indicator-line::before {
  content: "";
  position: absolute;
  left: -1px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 8px solid #EF4444;
  z-index: 101;
}
.fc .fc-timegrid .fc-timegrid-slot {
  height: 60px;
  border-color: #E5E7EB !important;
}
.fc .fc-timegrid .fc-timegrid-slot.fc-timegrid-slot-minor {
  border-top-style: solid !important;
  border-color: #E5E7EB !important;
}
.fc .fc-timegrid .fc-timegrid-slot-label {
  color: #6B7280;
  font-size: 12px;
  padding-right: 8px;
  vertical-align: top !important;
}
.fc .fc-timegrid .fc-timegrid-axis-cushion {
  padding-top: 0 !important;
  margin-top: -10px !important;
}
.fc .fc-timegrid .fc-timegrid-axis-frame {
  border-top: 1px solid #E5E7EB;
}
.fc .fc-timegrid .fc-timegrid-slot-lane {
  border-top: 1px solid #E5E7EB;
  margin-top: -50px !important;
  color: black !important;
}
.fc .fc-timegrid .fc-timegrid-slot-minor .fc-timegrid-slot-label-frame {
  display: none;
}
.fc .fc-timegrid .fc-timegrid-slot-label-cushion:has-text("12 AM") {
  visibility: hidden;
}
.fc .fc-timegrid .fc-timegrid-slot[data-time="00:00:00"] .fc-timegrid-slot-label-cushion {
  visibility: hidden;
}
.fc .fc-timegrid .fc-timegrid-axis {
  min-width: 80px !important;
  padding: 0 8px;
  z-index: 1 !important;
  position: relative;
}
.fc .fc-timegrid .fc-timegrid-axis .fc-timegrid-slot {
  border-top: none !important;
}
.fc .fc-timegrid .fc-timegrid-axis .fc-timegrid-slot::before {
  content: "";
  position: absolute;
  top: 0;
  height: 1px;
  background-color: #E5E7EB;
  z-index: 1;
}
.fc .fc-timegrid-axis {
  color: black !important;
  margin-top: -50px !important;
}
.fc .fc-timegrid-slot-label {
  white-space: nowrap !important;
  overflow: visible !important;
}
.fc .fc-timegrid-axis-cushion,
.fc .fc-timegrid-slot-label-cushion {
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: clip !important;
}
.fc .fc-timegrid-divider {
  min-height: 30px !important;
}
.fc .fc-daygrid .fc-daygrid-day.fc-day-today {
  background: #EFF6FF;
}
.fc .fc-daygrid .fc-daygrid-day.fc-day-sat, .fc .fc-daygrid .fc-daygrid-day.fc-day-sun {
  background: #F9FAFB;
}
.fc .fc-daygrid .fc-daygrid-day-number {
  padding: 8px;
  color: #374151;
  font-weight: 500;
}
.fc .fc-daygrid .fc-daygrid-more-link {
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  padding: 2px 4px;
  margin: 2px 4px;
}
.fc .fc-daygrid .fc-daygrid-more-link:hover {
  background: #F3F4F6;
  border-radius: 4px;
}
.fc .fc-event {
  border: none;
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 13px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
  overflow: hidden;
  z-index: 10;
}
.fc .fc-event:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 20;
}
.fc .fc-event.short-event {
  padding: 0px 3px;
}
.fc .fc-event.short-event .fc-event-main {
  padding: 0 2px;
}
.fc .fc-event.fc-timegrid-event .fc-event-main {
  display: flex;
  align-items: flex-start;
}
.fc .fc-event.completed-assignment {
  opacity: 0.25 !important;
}
.fc .fc-event.suggested-event {
  border: 2px dashed currentColor !important;
}
.fc .fc-event.suggested-event .fc-event-main {
  position: relative;
  overflow: hidden;
}
.fc .fc-event.suggested-event .fc-event-main::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: styles_shimmer__GLFda 2s infinite;
}
.fc .fc-list-table .suggested-event::after {
  display: none;
}
.fc .fc-list-table .suggested-event .fc-list-event-title {
  position: relative;
  overflow: hidden;
  z-index: 0;
}
.fc .fc-list-table .suggested-event .fc-list-event-title::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: styles_shimmer__GLFda 2s infinite;
}
@keyframes styles_shimmer__GLFda {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.fc .fc-day-today {
  background: #EFF6FF !important;
  z-index: 0 !important;
}
.fc .fc-day-today .fc-daygrid-day-number {
  background: #3B82F6;
  color: white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px;
  position: relative;
  z-index: 2;
}
.fc .fc-list {
  border: none;
}
.fc .fc-list .fc-list-day {
  background: #F9FAFB;
  font-weight: 600;
  color: #111827;
}
.fc .fc-list .fc-list-day > * {
  background: #F3F4F6 !important;
  z-index: 200 !important;
}
.fc .fc-list .fc-list-day .fc-list-day-cushion {
  background: #F3F4F6 !important;
}
.fc .fc-list .fc-list-day .ocean-tz-portal {
  display: none;
}
.fc .fc-list .fc-list-day .fc-list-day-cushion.ocean-tz-topmost .ocean-tz-portal {
  display: inline-flex;
}
.fc .fc-list .fc-list-event {
  cursor: pointer;
}
.fc .fc-list .fc-list-event:hover {
  background: #F3F4F6;
}
.fc .fc-list .fc-list-event .fc-list-event-dot {
  border-radius: 2px;
  width: 10px;
  height: 10px;
}
.fc .fc-list .fc-list-event .fc-list-event-title {
  color: #111827;
}
.fc .fc-list .fc-list-event .fc-list-event-time {
  color: #6B7280;
}

.styles_customEventContent__fmmbU {
  position: relative;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  height: 100%;
  padding-top: 0;
}
.styles_customEventContent__fmmbU.styles_completedTask__Yq3Dd .styles_eventTitle__N6tPw {
  text-decoration: line-through;
}
.styles_customEventContent__fmmbU .styles_taskCheckbox__K4JB9 {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.8);
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
  margin-top: 2px;
  z-index: 100;
}
.styles_customEventContent__fmmbU .styles_taskCheckbox__K4JB9:hover {
  border-color: rgb(255, 255, 255);
  background: rgba(255, 255, 255, 0.1);
  transform: scale(1.1);
}
.styles_customEventContent__fmmbU .styles_taskCheckbox__K4JB9:active {
  transform: scale(0.95);
}
.styles_customEventContent__fmmbU .styles_taskCheckbox__K4JB9.styles_checked__QEoWK {
  border-color: transparent;
  background: transparent;
}
.styles_customEventContent__fmmbU .styles_taskCheckbox__K4JB9.styles_checked__QEoWK:hover {
  background: rgba(255, 255, 255, 0.1);
}
.styles_customEventContent__fmmbU .styles_taskCheckbox__K4JB9 .styles_checkIcon__u\\+jwx {
  width: 18px;
  height: 18px;
  color: rgba(255, 255, 255, 0.9);
  stroke-width: 2.5;
}
.styles_customEventContent__fmmbU .fc-event.completed-assignment .styles_taskCheckbox__K4JB9 {
  opacity: 1;
}
.styles_customEventContent__fmmbU .styles_eventDetails__\\+rsOz {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.styles_customEventContent__fmmbU.styles_monthView__31fp3 {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  overflow: hidden;
}
.styles_customEventContent__fmmbU.styles_monthView__31fp3 .styles_eventTime__N8Zca {
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
.styles_customEventContent__fmmbU.styles_monthView__31fp3 .styles_eventCourse__xbqhF {
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
}
.styles_customEventContent__fmmbU .styles_eventTime__N8Zca {
  font-size: 11px;
  opacity: 0.8;
  margin-bottom: 2px;
}
.styles_customEventContent__fmmbU .styles_eventTitle__N6tPw {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.1;
  transition: -webkit-text-decoration 0.2s ease;
  transition: text-decoration 0.2s ease;
  transition: text-decoration 0.2s ease, -webkit-text-decoration 0.2s ease;
  margin-top: 0;
}
.styles_customEventContent__fmmbU .styles_eventLocation__xRGS9 {
  font-size: 11px;
  opacity: 0.7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 4px;
}
.styles_customEventContent__fmmbU .styles_eventLocation__xRGS9 .styles_locationIcon__zIl9g {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
}
.styles_customEventContent__fmmbU .styles_eventGrade__lgc0\\+ {
  font-size: 11px;
  font-weight: 600;
  margin-top: 2px;
  opacity: 0.9;
}

.fc-list .styles_taskCheckbox__K4JB9 {
  border-color: #D1D5DB;
}
.fc-list .styles_taskCheckbox__K4JB9:hover {
  border-color: #9CA3AF;
  background: rgba(0, 0, 0, 0.05);
}
.fc-list .styles_taskCheckbox__K4JB9.styles_checked__QEoWK {
  border-color: transparent;
}
.fc-list .styles_taskCheckbox__K4JB9 .styles_checkIcon__u\\+jwx {
  color: #374151;
}

.styles_eventPopover__wz4G6 {
  position: fixed;
  background: white;
  border-radius: 12px;
  border: 3px solid;
  width: 500px;
  max-height: 80vh;
  overflow: visible;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  animation: styles_popIn__dm3hq 0.15s ease-out;
}
@media (max-width: 767px) {
  .styles_eventPopover__wz4G6 {
    width: calc(100vw - 32px);
    max-width: 350px;
    left: 50% !important;
    transform: translateX(-50%);
    top: 175px !important;
  }
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC {
  padding: 20px 20px 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
  flex: 1 1;
  padding-right: 10px;
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_headerActions__AbAxc {
  display: flex;
  align-items: center;
  gap: 4px;
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_iconBtn__zsKBH {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s;
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_iconBtn__zsKBH:hover {
  background: #F3F4F6;
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_iconBtn__zsKBH:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_iconBtn__zsKBH .styles_actionIcon__nPjAW {
  width: 18px;
  height: 18px;
  color: #6B7280;
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_iconBtn__zsKBH.styles_deleteBtn__q8P0M .styles_actionIcon__nPjAW {
  filter: invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(60%) contrast(90%);
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_iconBtn__zsKBH.styles_deleteBtn__q8P0M:hover {
  background: #FEE2E2;
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_iconBtn__zsKBH.styles_deleteBtn__q8P0M:hover .styles_actionIcon__nPjAW {
  filter: invert(22%) sepia(90%) saturate(2000%) hue-rotate(346deg) brightness(90%) contrast(95%);
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_closeBtn__41Fhf {
  background: none;
  border: none;
  font-size: 24px;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
  flex-shrink: 0;
}
.styles_eventPopover__wz4G6 .styles_modalHeader__ripPC .styles_closeBtn__41Fhf:hover {
  background: #F3F4F6;
  color: #111827;
}
.styles_eventPopover__wz4G6 .styles_modalDateTime__4WiNM {
  padding: 0 20px 16px 20px;
  font-size: 14px;
}
.styles_eventPopover__wz4G6 .styles_modalDateTime__4WiNM .styles_dateText__ficBH {
  color: #374151;
  font-weight: 500;
}
.styles_eventPopover__wz4G6 .styles_modalDivider__8gAls {
  height: 1px;
  background: #E5E7EB;
  margin: 0 20px 16px 20px;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W {
  padding: 0 20px 20px 20px;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_locationRow__h7\\+6M {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #374151;
  font-size: 14px;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_locationRow__h7\\+6M .styles_locationIconModal__WLfAw {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #6B7280;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_description__h6KxA {
  color: #4B5563;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_aiReasoning__m0-0U {
  margin-top: 16px;
  padding: 12px;
  background: #EFF6FF;
  border-radius: 8px;
  border: 1px solid #BFDBFE;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_aiReasoning__m0-0U .styles_reasoningLabel__p\\+vIx {
  font-size: 12px;
  font-weight: 600;
  color: #2563EB;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_aiReasoning__m0-0U p {
  margin: 8px 0 0 0;
  font-size: 13px;
  color: #1D4ED8;
  line-height: 1.4;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_aiReasoning__m0-0U .styles_userSelectedTime__oLA88 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #2563EB;
  font-weight: 500;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_aiReasoning__m0-0U .styles_infoIcon__2Zhjl {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_suggestionActions__6w2up {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_dismissBtn__TST9K {
  flex: 1 1;
  padding: 10px 16px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_dismissBtn__TST9K:hover {
  background: #F9FAFB;
  border-color: #D1D5DB;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_acceptBtn__om0bL {
  flex: 1 1;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  background: #3B82F6;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.styles_eventPopover__wz4G6 .styles_modalBody__eOh8W .styles_acceptBtn__om0bL:hover {
  background: #2563EB;
}
.styles_eventPopover__wz4G6 .styles_suggestionBadge__g5Ao9 {
  margin: 0 20px 12px 20px;
  padding: 4px 10px;
  background: linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%);
  color: white;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 4px;
  display: inline-block;
}
.styles_eventPopover__wz4G6 .styles_importSourceRow__6wz1H {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 20px 12px 20px;
  font-size: 11px;
  color: #666;
}
.styles_eventPopover__wz4G6 .styles_importSourceRow__6wz1H .styles_infoIcon__2Zhjl {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  color: #666;
}
.styles_eventPopover__wz4G6 .styles_importSourceRow__6wz1H .styles_importSourceText__5Zek6 {
  line-height: 1.4;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ {
  padding: 0 20px 20px 20px;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formGroup__ionGn {
  margin-bottom: 16px;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formGroup__ionGn label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formGroup__ionGn input,
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formGroup__ionGn textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1.5px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background: white;
  transition: all 0.2s;
  font-family: inherit;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formGroup__ionGn input:focus,
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formGroup__ionGn textarea:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formGroup__ionGn input::placeholder,
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formGroup__ionGn textarea::placeholder {
  color: #9CA3AF;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formGroup__ionGn textarea {
  resize: vertical;
  min-height: 80px;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formRow__Uf4Pd {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
@media (max-width: 767px) {
  .styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formRow__Uf4Pd {
    grid-template-columns: 1fr;
  }
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formRow__Uf4Pd .styles_formGroup__ionGn {
  margin-bottom: 16px;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_datePicker__wcCtr {
  width: 100%;
  min-width: 180px;
  padding: 10px 12px;
  border: 1.5px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_datePicker__wcCtr:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_courseSelect__UO9Jf {
  width: 100%;
  padding: 10px 12px;
  border: 1.5px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_courseSelect__UO9Jf:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formActions__ndExz {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formActions__ndExz .styles_cancelBtn__1hleq,
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formActions__ndExz .styles_saveBtn__B2g7B {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formActions__ndExz .styles_cancelBtn__1hleq:disabled,
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formActions__ndExz .styles_saveBtn__B2g7B:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formActions__ndExz .styles_cancelBtn__1hleq {
  background: #F3F4F6;
  color: #374151;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formActions__ndExz .styles_cancelBtn__1hleq:hover:not(:disabled) {
  background: #E5E7EB;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formActions__ndExz .styles_saveBtn__B2g7B {
  background: #3B82F6;
  color: white;
}
.styles_eventPopover__wz4G6 .styles_editForm__4R4v\\+ .styles_formActions__ndExz .styles_saveBtn__B2g7B:hover:not(:disabled) {
  background: #2563EB;
}

.react-datepicker {
  font-family: inherit;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.react-datepicker__header {
  background: #F9FAFB;
  border-bottom: 1px solid #E5E7EB;
  border-radius: 12px 12px 0 0;
  padding-top: 12px;
}

.react-datepicker__current-month {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
}

.react-datepicker__day-name {
  color: #6B7280;
  font-weight: 500;
  font-size: 12px;
  width: 32px;
  line-height: 32px;
}

.react-datepicker__day {
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 50%;
  color: #374151;
  font-size: 13px;
  transition: all 0.15s;
}
.react-datepicker__day:hover {
  background: #F3F4F6;
  border-radius: 50%;
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
  background: #3B82F6 !important;
  color: white !important;
  border-radius: 50% !important;
  font-weight: 500;
}
.react-datepicker__day--selected:hover,
.react-datepicker__day--keyboard-selected:hover {
  background: #2563EB !important;
  border-radius: 50% !important;
}

.react-datepicker__day--today {
  font-weight: 600;
  color: #3B82F6;
}
.react-datepicker__day--today:not(.styles_react-datepicker__day--selected__P6WUq) {
  background: transparent;
}

.react-datepicker__day--outside-month {
  color: #D1D5DB;
}

.react-datepicker__navigation {
  top: 12px;
}

.react-datepicker__navigation-icon::before {
  border-color: #6B7280;
}

.react-datepicker__time-container {
  border-left: 1px solid #E5E7EB;
}

.react-datepicker__time-list-item {
  font-size: 13px;
  padding: 8px 12px !important;
}
.react-datepicker__time-list-item:hover {
  background: #F3F4F6 !important;
}

.react-datepicker__time-list-item--selected {
  background: #3B82F6 !important;
  color: white !important;
  font-weight: 500;
}

.react-datepicker-popper {
  z-index: 10000 !important;
  margin-left: 50px !important;
}
@media (max-width: 767px) {
  .react-datepicker-popper {
    margin-left: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
}

@media (max-width: 767px) {
  .react-datepicker {
    min-width: 340px;
  }
  .react-datepicker__month-container {
    width: 250px;
  }
  .react-datepicker__time-container {
    width: 85px;
  }
}
.styles_undoToast__o5X86 {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 10001;
  animation: styles_slideUp__YZMKK 0.2s ease-out;
}
.styles_undoToast__o5X86 span {
  font-size: 14px;
  color: #374151;
}
.styles_undoToast__o5X86 .styles_undoButton__ARIXa {
  background: #3B82F6;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.styles_undoToast__o5X86 .styles_undoButton__ARIXa:hover {
  background: #2563EB;
}

@keyframes styles_slideUp__YZMKK {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
@keyframes styles_fadeIn__MTauJ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes styles_popIn__dm3hq {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@media (max-width: 768px) {
  .fc .fc-toolbar {
    flex-direction: column;
  }
  .fc .fc-toolbar .fc-toolbar-chunk {
    display: flex;
    justify-content: center;
    margin: 5px 0;
    width: 100%;
  }
  .fc .fc-toolbar .fc-toolbar-title {
    font-size: 18px;
  }
  .fc .fc-event .styles_customEventContent__fmmbU .styles_eventLocation__xRGS9,
  .fc .fc-event .styles_customEventContent__fmmbU .styles_eventGrade__lgc0\\+ {
    display: none;
  }
  .fc .fc-event .styles_customEventContent__fmmbU .styles_taskCheckbox__K4JB9 {
    width: 24px;
    height: 24px;
    border-width: 2.5px;
  }
  .fc .fc-event .styles_customEventContent__fmmbU .styles_taskCheckbox__K4JB9 .styles_checkIcon__u\\+jwx {
    width: 20px;
    height: 20px;
  }
  .fc .fc-timegrid-event .styles_customEventContent__fmmbU {
    height: 100%;
  }
  .fc .fc-timegrid-event .styles_customEventContent__fmmbU .styles_eventTime__N8Zca {
    display: none;
  }
  .fc .fc-timegrid-event .styles_customEventContent__fmmbU .styles_eventTitle__N6tPw {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: unset;
  }
  .fc .fc-daygrid-event .styles_customEventContent__fmmbU.styles_monthView__31fp3 .styles_eventTime__N8Zca {
    display: none;
  }
  .fc .fc-daygrid-event .styles_customEventContent__fmmbU.styles_monthView__31fp3 .styles_eventCourse__xbqhF {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .fc .fc-list {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
  }
  .fc .fc-list .fc-list-table {
    width: 100% !important;
    table-layout: fixed !important;
  }
  .fc .fc-list .fc-list-day-cushion {
    padding: 8px 12px !important;
  }
  .fc .fc-list .fc-list-day-cushion .fc-list-day-text,
  .fc .fc-list .fc-list-day-cushion .fc-list-day-side-text {
    font-size: 13px;
  }
  .fc .fc-list .fc-list-event-time {
    font-size: 12px !important;
    padding: 8px 4px 8px 12px !important;
    width: 90px !important;
  }
  .fc .fc-list .fc-list-event-graphic {
    padding: 8px 4px !important;
    width: 20px !important;
  }
  .fc .fc-list .fc-list-event-title {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    padding: 8px 12px 8px 4px !important;
    font-size: 13px !important;
  }
}
.styles_mobileCalendarHeader__W09Rk {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: white;
  border-bottom: 1px solid #E5E7EB;
  position: relative;
  z-index: 101;
}
@media (max-width: 375px) {
  .styles_mobileCalendarHeader__W09Rk {
    padding: 12px 16px;
  }
}
.styles_mobileCalendarHeader__W09Rk .styles_mobileHeaderLeft__vWO2N {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.styles_mobileCalendarHeader__W09Rk .styles_hamburgerButton__aliBF {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #374151;
  transition: background 0.2s;
  border-radius: 6px;
}
.styles_mobileCalendarHeader__W09Rk .styles_hamburgerButton__aliBF:hover {
  background: #F3F4F6;
}
.styles_mobileCalendarHeader__W09Rk .styles_hamburgerButton__aliBF:active {
  background: #E5E7EB;
}
.styles_mobileCalendarHeader__W09Rk .styles_mobileViewDropdown__\\+IS1- {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  overflow: hidden;
  z-index: 1000;
  animation: styles_slideDown__uB0Gf 0.2s ease-out;
}
.styles_mobileCalendarHeader__W09Rk .styles_mobileViewOption__bQQsn {
  display: block;
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  text-align: left;
  font-size: 15px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s;
  font-weight: 400;
}
.styles_mobileCalendarHeader__W09Rk .styles_mobileViewOption__bQQsn:hover {
  background: #F3F4F6;
}
.styles_mobileCalendarHeader__W09Rk .styles_mobileViewOption__bQQsn.styles_active__xyHD0 {
  color: #3B82F6;
  font-weight: 600;
  background: #EFF6FF;
}
.styles_mobileCalendarHeader__W09Rk .styles_mobileViewOption__bQQsn:not(:last-child) {
  border-bottom: 1px solid #F3F4F6;
}
.styles_mobileCalendarHeader__W09Rk .styles_dropdownSeparator__RFYB7 {
  height: 1px;
  background: #E5E7EB;
  margin: 4px 0;
}
.styles_mobileCalendarHeader__W09Rk .styles_syncOption__To\\+3l {
  display: flex;
  align-items: center;
  gap: 12px;
}
.styles_mobileCalendarHeader__W09Rk .styles_syncOption__To\\+3l .styles_optionIcon__loU3n {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.styles_mobileCalendarHeader__W09Rk .styles_syncOption__To\\+3l .styles_optionIcon__loU3n svg {
  width: 100%;
  height: 100%;
}
.styles_mobileCalendarHeader__W09Rk .styles_syncOption__To\\+3l.styles_connected__xU-B0 {
  color: #3B82F6;
}
.styles_mobileCalendarHeader__W09Rk .styles_syncOption__To\\+3l.styles_connected__xU-B0 .styles_optionIcon__loU3n svg {
  fill: #3B82F6;
}
.styles_mobileCalendarHeader__W09Rk .styles_syncOption__To\\+3l .styles_statusIndicator__LAoWi {
  margin-left: auto;
  color: #3B82F6;
  font-size: 20px;
  line-height: 1;
}
.styles_mobileCalendarHeader__W09Rk .styles_syncOption__To\\+3l:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.styles_mobileCalendarHeader__W09Rk .styles_mobileHeaderCenter__hJSej {
  flex: 1 1;
  display: flex;
  justify-content: center;
  padding: 0 16px;
  min-width: 0;
}
@media (max-width: 375px) {
  .styles_mobileCalendarHeader__W09Rk .styles_mobileHeaderCenter__hJSej {
    padding: 0 8px;
  }
}
.styles_mobileCalendarHeader__W09Rk .styles_mobileTitle__5W9pE {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
@media (max-width: 375px) {
  .styles_mobileCalendarHeader__W09Rk .styles_mobileTitle__5W9pE {
    font-size: 16px;
  }
}
.styles_mobileCalendarHeader__W09Rk .styles_mobileHeaderRight__8VIYF {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
@media (max-width: 375px) {
  .styles_mobileCalendarHeader__W09Rk .styles_mobileHeaderRight__8VIYF {
    gap: 4px;
  }
}
.styles_mobileCalendarHeader__W09Rk .styles_navArrowButton__UmK0F {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #374151;
  transition: background 0.2s;
  border-radius: 6px;
}
.styles_mobileCalendarHeader__W09Rk .styles_navArrowButton__UmK0F:hover {
  background: #F3F4F6;
}
.styles_mobileCalendarHeader__W09Rk .styles_navArrowButton__UmK0F:active {
  background: #E5E7EB;
}
.styles_mobileCalendarHeader__W09Rk .styles_chatbotButton__g4Dtc {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #374151;
  transition: background 0.2s, transform 0.2s;
  border-radius: 6px;
  margin-left: 4px;
}
.styles_mobileCalendarHeader__W09Rk .styles_chatbotButton__g4Dtc:hover {
  background: #F3F4F6;
  transform: translateY(-1px);
}
.styles_mobileCalendarHeader__W09Rk .styles_chatbotButton__g4Dtc:active {
  background: #E5E7EB;
  transform: translateY(0);
}
.styles_mobileCalendarHeader__W09Rk .styles_oceanLogo__4Xqmu {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

@keyframes styles_slideDown__uB0Gf {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .styles_syncToolbarElement__O\\+Y94 {
    display: none;
  }
  .styles_inlineToolbarElements__cDCs- {
    display: none;
  }
}
/* --- MOBILE SPECIFIC STYLES --- */
@media (max-width: 768px) {
  /* 1. HIDE DESKTOP ELEMENTS (Critical for your previous request) */
  .styles_syncToolbarElement__O\\+Y94,
  .styles_inlineToolbarElements__cDCs-,
  .fc-header-toolbar {
    display: none !important;
  }
  /* 2. FIX HEADER OVERFLOW (The "No Overflow" Fix) */
  .fc {
    /* Target the container of the date text */
  }
  .fc .fc-col-header-cell {
    padding: 0 !important; /* Zero padding around the cell */
    vertical-align: middle;
  }
  .fc {
    /* Target the text itself (e.g., "Sun 12") */
  }
  .fc .fc-col-header-cell-cushion {
    /* Dynamic Font Size:
       - Minimum: 9px (so it's never unreadable)
       - Preferred: 3.5% of viewport width (scales with phone width)
       - Maximum: 12px (caps it so it doesn't get huge on tablets) 
    */
    font-size: clamp(9px, 3.5vw, 12px) !important;
    /* Squeeze spacing */
    letter-spacing: -0.5px !important;
    padding: 4px 0 !important; /* Top/bottom padding only */
    width: 100%; /* Force it to fill the cell */
    display: block !important; /* Helps centering */
  }
  /* ... Your other mobile tweaks (like the event styles) go here ... */
}`, "",{"version":3,"sources":["webpack://./src/screens/calendar/styles.module.scss"],"names":[],"mappings":"AACA;EACE,UAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAAF;AAGE;EACE,UAAA;AADJ;AAGE;EACE,uBAAA;AADJ;AAGE;EACE,+BAAA;EACA,kBAAA;AADJ;AAGE;EACE,aAAA;AADJ;AAKE;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAHJ;AAOE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AALJ;AAQI;EACE,YAAA;AANN;AAUI;EACE,YAAA;AARN;AAaE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAXJ;AAcE;EACE,kBAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;AAbJ;AAeI;EACE,mBAAA;AAbN;AAgBI;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AAdN;AAgBM;EACE,yBAAA;AAdR;AAmBE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;AAlBJ;AAoBI;EACE,mBAAA;AAlBN;AAqBI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AAnBN;AAuBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,+BAAA;AArBJ;AAuBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AArBN;AAwBI;EACE,2BAAA;AAtBN;AA0BE;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAxBJ;AA4BM;EACE,YAAA;AA1BR;AA8BI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AA5BN;AAiCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AA/BJ;AAkCE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,0JAAA;EAQA,wDAAA;AAvCJ;AA0CE;EACE;IACE,WAAA;EAxCJ;EA0CE;IACE,UAAA;EAxCJ;AACF;AA4CE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;AA1CJ;AA6CE;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;AA3CJ;AA6CI;EACE,qCAAA;AA3CN;;AAoDA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AAjDF;;AAoDA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;AAjDF;AAmDE;EACE,yBAAA;AAjDJ;AAoDE;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AAlDJ;;AAuDA;EACE,8JAAA;AApDF;AAyDE;EACE,mBAAA;EACA,eAAA;EACA,SAAA;AAvDJ;AAyDI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAvDN;AA2DM;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAzDR;AA2DQ;EACE,mBAAA;EACA,qBAAA;AAzDV;AA4DQ;EACE,6CAAA;AA1DV;AA6DQ;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AA3DV;AA6DU;EACE,mBAAA;EACA,qBAAA;AA3DZ;AA+DQ;EACE,YAAA;EACA,mBAAA;AA7DV;AAkEI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAhEN;AAkEM;EACE,mBAAA;AAhER;AAmEM;EACE,YAAA;EACA,mBAAA;AAjER;AAuEE;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;AArEJ;AAwEI;EACE,gCAAA;AAtEN;AA2EI;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAzEN;AA8EE;EACE,oCAAA;EACA,kBAAA;AA5EJ;AA8EI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,qBAAA;EACA,MAAA;EACA,YAAA;EACA,6BAAA;AA5EN;AAiFE;EACE,aAAA;AA/EJ;AAkFE;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAhFJ;AAkFI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;EACA,8BAAA;EACA,YAAA;AAhFN;AAsFI;EACE,YAAA;EACA,gCAAA;AApFN;AAsFM;EACE,kCAAA;EACA,gCAAA;AApFR;AAwFI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;AAtFN;AA0FI;EACE,yBAAA;EACA,4BAAA;AAxFN;AA2FI;EACA,6BAAA;AAzFJ;AA6FA;EACI,6BAAA;EAEA,4BAAA;EACA,uBAAA;AA5FJ;AAgGI;EACE,aAAA;AA9FN;AAmGM;EACE,kBAAA;AAjGR;AAsGI;EACE,kBAAA;AApGN;AAuGI;EACE,0BAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AArGN;AAwGM;EACE,2BAAA;AAtGR;AAwGM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EAGA,WAAA;EACA,yBAAA;EACA,UAAA;AAxGR;AA4HE;EACM,uBAAA;EAEA,4BAAA;AA3HR;AA+HE;EACE,8BAAA;EACA,4BAAA;AA7HJ;AAgIE;;EAEE,8BAAA;EACA,4BAAA;EACA,8BAAA;AA9HJ;AAkIE;EACE,2BAAA;AAhIJ;AAsIM;EACE,mBAAA;AApIR;AAuIM;EAEE,mBAAA;AAtIR;AA0II;EACE,YAAA;EACA,cAAA;EACA,gBAAA;AAxIN;AA4II;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA1IN;AA4IM;EACE,mBAAA;EACA,kBAAA;AA1IR;AAgJE;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yDAAA;EACA,gBAAA;EACA,WAAA;AA9IJ;AAgJI;EACE,2BAAA;EACA,wCAAA;EACA,WAAA;AA9IN;AAkJI;EACE,gBAAA;AAhJN;AAkJM;EACE,cAAA;AAhJR;AAsJM;EACE,aAAA;EACA,uBAAA;AApJR;AAyJI;EACE,wBAAA;AAvJN;AA2JI;EACE,0CAAA;AAzJN;AAgKM;EACE,kBAAA;EACA,gBAAA;AA9JR;AAgKQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAMA,4CAAA;AAnKV;AA6KI;EACE,aAAA;AA3KN;AA8KI;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;AA5KN;AA8KM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAMA,4CAAA;AAjLR;AAsLE;EACE;IACE,WAAA;EApLJ;EAsLE;IACE,UAAA;EApLJ;AACF;AAwLE;EACE,8BAAA;EACA,qBAAA;AAtLJ;AAwLI;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAtLN;AA2LE;EACE,YAAA;AAzLJ;AA2LI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAzLN;AAkMM;EACE,8BAAA;EACA,uBAAA;AAhMR;AAmMM;EACE,8BAAA;AAjMR;AAsMM;EACE,aAAA;AApMR;AAsMM;EACE,oBAAA;AApMR;AAwMI;EACE,eAAA;AAtMN;AAwMM;EACE,mBAAA;AAtMR;AAyMM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAvMR;AA0MM;EACE,cAAA;AAxMR;AA2MM;EACE,cAAA;AAzMR;;AAgNA;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AA7MF;AAiNI;EACE,6BAAA;AA/MN;AAoNE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;AAlNJ;AAoNI;EACE,gCAAA;EACA,oCAAA;EACA,qBAAA;AAlNN;AAqNI;EACE,sBAAA;AAnNN;AAsNI;EACE,yBAAA;EACA,uBAAA;AApNN;AAsNM;EACE,oCAAA;AApNR;AAwNI;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,iBAAA;AAtNN;AA4NI;EACE,UAAA;AA1NN;AA8NE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA5NJ;AA+NE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;AA7NJ;AA+NI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA7NN;AAgOI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AA9NN;AAkOE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AAhOJ;AAmOE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,6CAAA;EAAA,qCAAA;EAAA,wEAAA;EACA,aAAA;AAjOJ;AAoOE;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlOJ;AAoOI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAlON;AAsOE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AApOJ;;AA4OE;EACE,qBAAA;AAzOJ;AA2OI;EACE,qBAAA;EACA,+BAAA;AAzON;AA4OI;EACE,yBAAA;AA1ON;AA6OI;EACE,cAAA;AA3ON;;AAiPA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,yEAAA;EAEA,aAAA;EACA,6CAAA;AA/OF;AAkPE;EAdF;IAeI,yBAAA;IACA,gBAAA;IACA,oBAAA;IACA,2BAAA;IACA,qBAAA;EA/OF;AACF;AAiPE;EACE,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AA/OJ;AAiPI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AA/ON;AAkPI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhPN;AAmPI;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AAjPN;AAmPM;EACE,mBAAA;AAjPR;AAoPM;EACE,YAAA;EACA,mBAAA;AAlPR;AAqPM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAnPR;AAuPQ;EAEE,yFAAA;AAtPV;AAyPQ;EACE,mBAAA;AAvPV;AAyPU;EACE,+FAAA;AAvPZ;AA6PI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;AA3PN;AA6PM;EACE,mBAAA;EACA,cAAA;AA3PR;AAgQE;EACE,yBAAA;EACA,eAAA;AA9PJ;AAgQI;EACE,cAAA;EACA,gBAAA;AA9PN;AAkQE;EACE,WAAA;EACA,mBAAA;EACA,wBAAA;AAhQJ;AAmQE;EACE,yBAAA;AAjQJ;AAmQI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAjQN;AAmQM;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAjQR;AAqQI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAnQN;AAsQI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AApQN;AAsQM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AApQR;AAuQM;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AArQR;AAwQM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAtQR;AAyQM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAvQR;AA2QI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAzQN;AA4QI;EACE,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA1QN;AA4QM;EACE,mBAAA;EACA,qBAAA;AA1QR;AA8QI;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA5QN;AA8QM;EACE,mBAAA;AA5QR;AAiRE;EACE,wBAAA;EACA,iBAAA;EACA,6DAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;AA/QJ;AAkRE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;AAhRJ;AAkRI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;AAhRN;AAmRI;EACE,gBAAA;AAjRN;AAsRE;EACE,yBAAA;AApRJ;AAsRI;EACE,mBAAA;AApRN;AAsRM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AApRR;AAuRM;;EAEE,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;AArRR;AAuRQ;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AApRV;AAuRQ;;EACE,cAAA;AApRV;AAwRM;EACE,gBAAA;EACA,gBAAA;AAtRR;AA0RI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAxRN;AA2RM;EANF;IAOI,0BAAA;EAxRN;AACF;AA0RM;EACE,mBAAA;AAxRR;AA4RI;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AA1RN;AA4RM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA1RR;AA8RI;EACE,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,mBAAA;AA5RN;AA8RM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA5RR;AAgSI;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AA9RN;AAgSM;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AA9RR;AAgSQ;;EACE,YAAA;EACA,mBAAA;AA7RV;AAiSM;EACE,mBAAA;EACA,cAAA;AA/RR;AAiSQ;EACE,mBAAA;AA/RV;AAmSM;EACE,mBAAA;EACA,YAAA;AAjSR;AAmSQ;EACE,mBAAA;AAjSV;;AAySA;EACE,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;AAtSF;;AAySA;EACE,mBAAA;EACA,gCAAA;EACA,4BAAA;EACA,iBAAA;AAtSF;;AAySA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAtSF;;AAySA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AAtSF;;AAySA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAtSF;AAwSE;EACE,mBAAA;EACA,kBAAA;AAtSJ;;AA0SA;;EAEE,8BAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;AAvSF;AAySE;;EACE,8BAAA;EACA,6BAAA;AAtSJ;;AA0SA;EACE,gBAAA;EACA,cAAA;AAvSF;AAySE;EACE,uBAAA;AAvSJ;;AA2SA;EACE,cAAA;AAxSF;;AA2SA;EACE,SAAA;AAxSF;;AA2SA;EACE,qBAAA;AAxSF;;AA2SA;EACE,8BAAA;AAxSF;;AA2SA;EACE,eAAA;EACA,4BAAA;AAxSF;AA0SE;EACE,8BAAA;AAxSJ;;AA4SA;EACE,8BAAA;EACA,uBAAA;EACA,gBAAA;AAzSF;;AA4SA;EACE,yBAAA;EACA,4BAAA;AAzSF;AA4SE;EALF;IAMI,yBAAA;IACA,oBAAA;IACA,sCAAA;EAzSF;AACF;;AA6SA;EACE;IACE,gBAAA;EA1SF;EA6SA;IACE,YAAA;EA3SF;EA8SA;IACE,WAAA;EA5SF;AACF;AAgTA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,8CAAA;AA9SF;AAgTE;EACE,eAAA;EACA,cAAA;AA9SJ;AAiTE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AA/SJ;AAiTI;EACE,mBAAA;AA/SN;;AAoTA;EACE;IACE,UAAA;IACA,4CAAA;EAjTF;EAmTA;IACE,UAAA;IACA,yCAAA;EAjTF;AACF;AAqTA;EACE;IACE,UAAA;EAnTF;EAqTA;IACE,UAAA;EAnTF;AACF;AAsTA;EACE;IACE,UAAA;IACA,sBAAA;EApTF;EAsTA;IACE,UAAA;IACA,mBAAA;EApTF;AACF;AAwTA;EAEI;IACE,sBAAA;EAvTJ;EAyTI;IACE,aAAA;IACA,uBAAA;IACA,aAAA;IACA,WAAA;EAvTN;EA0TI;IACE,eAAA;EAxTN;EA8TM;;IAEE,aAAA;EA5TR;EA+TM;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EA7TR;EA+TQ;IACE,WAAA;IACA,YAAA;EA7TV;EAqUI;IACE,YAAA;EAnUN;EAqUM;IACE,aAAA;EAnUR;EAqUM;IACE,mBAAA;IACA,qBAAA;IACA,yBAAA;IACA,gBAAA;IACA,oBAAA;IACA,4BAAA;IACA,yBAAA;EAnUR;EA2UM;IACE,aAAA;EAzUR;EA2UM;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;EAzUR;EA+UE;IACE,sBAAA;IACA,0BAAA;IACA,6BAAA;EA7UJ;EA+UI;IACE,sBAAA;IACA,8BAAA;EA7UN;EAiVI;IACE,4BAAA;EA/UN;EAiVM;;IAEE,eAAA;EA/UR;EAmVI;IACE,0BAAA;IACA,oCAAA;IACA,sBAAA;EAjVN;EAoVI;IACE,2BAAA;IACA,sBAAA;EAlVN;EAqVI;IACE,8BAAA;IACA,gCAAA;IACA,oCAAA;IACA,oCAAA;IACA,0BAAA;EAnVN;AACF;AAyVA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AAvVF;AAyVE;EAVF;IAWI,kBAAA;EAtVF;AACF;AAwVE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAtVJ;AAyVE;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;AAvVJ;AAyVI;EACE,mBAAA;AAvVN;AA0VI;EACE,mBAAA;AAxVN;AA4VE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,gDAAA;AA1VJ;AA6VE;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;AA3VJ;AA6VI;EACE,mBAAA;AA3VN;AA8VI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AA5VN;AA+VI;EACE,gCAAA;AA7VN;AAiWE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;AA/VJ;AAkWE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhWJ;AAkWI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAhWN;AAkWM;EACE,WAAA;EACA,YAAA;AAhWR;AAoWI;EACE,cAAA;AAlWN;AAoWM;EACE,aAAA;AAlWR;AAsWI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AApWN;AAuWI;EACE,YAAA;EACA,mBAAA;AArWN;AAyWE;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AAvWJ;AAyWI;EAPF;IAQI,cAAA;EAtWJ;AACF;AAyWE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAvWJ;AAyWI;EAVF;IAWI,eAAA;EAtWJ;AACF;AAyWE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAvWJ;AAyWI;EANF;IAOI,QAAA;EAtWJ;AACF;AAyWE;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;AAvWJ;AAyWI;EACE,mBAAA;AAvWN;AA0WI;EACE,mBAAA;AAxWN;AA4WE;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2CAAA;EACA,kBAAA;EACA,gBAAA;AA1WJ;AA4WI;EACE,mBAAA;EACA,2BAAA;AA1WN;AA6WI;EACE,mBAAA;EACA,wBAAA;AA3WN;AA+WE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA7WJ;;AAkXA;EACE;IACE,UAAA;IACA,2BAAA;EA/WF;EAiXA;IACE,UAAA;IACA,wBAAA;EA/WF;AACF;AAmXA;EACE;IACE,aAAA;EAjXF;EAoXA;IACE,aAAA;EAlXF;AACF;AAsXA,mCAAA;AACA;EAEE,kEAAA;EACA;;;IAGE,wBAAA;EArXF;EAwXA,mDAAA;EACA;IACE,0CAAA;EAtXF;EAuXE;IACE,qBAAA,EAAA,iCAAA;IACA,sBAAA;EArXJ;EAiXA;IAOE,4CAAA;EArXF;EAsXE;IACE;;;;KAAA;IAKA,6CAAA;IAEA,oBAAA;IACA,iCAAA;IACA,yBAAA,EAAA,4BAAA;IACA,WAAA,EAAA,8BAAA;IACA,yBAAA,EAAA,oBAAA;EArXJ;EAyXA,qEAAA;AAvXF","sourcesContent":["@import \"mixins\";\n.oceanCalendarWrapper {\n  padding: 0; // No horizontal padding - stretch to edges\n  background: #F9FAFB;\n  height: calc(100vh - 80px); // Exact height to fill viewport minus compact header (60px height + some padding)\n  overflow: hidden; // Prevent page scrolling\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  // Hide scrollbar arrows on Windows (FullCalendar time grid scroller)\n  :global(.fc-scroller)::-webkit-scrollbar {\n    width: 8px;\n  }\n  :global(.fc-scroller)::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  :global(.fc-scroller)::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.15);\n    border-radius: 4px;\n  }\n  :global(.fc-scroller)::-webkit-scrollbar-button {\n    display: none;\n  }\n\n  // Extend background up behind the header\n  &::before {\n    content: '';\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #F9FAFB;\n    z-index: -1;\n  }\n\n  // Sync button - always visible, positioned to left of view buttons\n  .syncToolbarElement {\n    position: absolute;\n    top: 25px; // Align with toolbar\n    display: flex;\n    align-items: center;\n    z-index: 100;\n\n    // When chatbot panel is open (less space)\n    &.chatbotOpen {\n      right: 280px;\n    }\n\n    // When chatbot panel is closed (more space, need to avoid nav dropdown)\n    &.chatbotClosed {\n      right: 340px;\n    }\n  }\n\n  // Inline toolbar elements (positioned within FullCalendar toolbar)\n  .inlineToolbarElements {\n    position: absolute;\n    top: 20px; // Align with toolbar\n    right: 290px; // Position before the sync button\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    z-index: 100;\n  }\n\n  .navDropdownContainer {\n    position: relative;\n  }\n\n  .navDropdownButton {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: none;\n    border: none;\n    font-size: 15px;\n    font-weight: 500;\n    color: #3B82F6;\n    cursor: pointer;\n    padding: 8px 12px;\n    border-radius: 8px;\n    transition: background 0.2s;\n\n    &:hover {\n      background: #F3F4F6;\n    }\n\n    .dropdownArrow {\n      width: 14px;\n      height: 14px;\n      transition: transform 0.2s ease;\n\n      &.open {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  .navDropdownMenu {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    margin-top: 4px;\n    background: white;\n    border: 1px solid #E5E7EB;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    min-width: 150px;\n    z-index: 1000;\n    overflow: hidden;\n  }\n\n  .navDropdownItem {\n    display: block;\n    width: 100%;\n    padding: 10px 16px;\n    background: none;\n    border: none;\n    text-align: left;\n    font-size: 14px;\n    color: #374151;\n    cursor: pointer;\n    transition: background 0.2s;\n\n    &:hover {\n      background: #F3F4F6;\n    }\n\n    &.active {\n      color: #3B82F6;\n      font-weight: 500;\n      background: #EFF6FF;\n    }\n  }\n\n  .chatbotToggle {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    padding: 4px;\n    transition: transform 0.2s ease;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n\n    &:hover {\n      transform: translateY(-2px);\n    }\n  }\n\n  .calendarContainer {\n    background: white;\n    border-radius: 0; // No rounded corners - stretch to edges\n    padding: 20px;\n    box-shadow: none; // Remove shadow since it's edge-to-edge\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    position: relative; // Required for inlineToolbarElements positioning\n\n    &.isLoading {\n      // Slightly fade the calendar while loading\n      :global(.fc) {\n        opacity: 0.6;\n      }\n    }\n\n    :global(.fc) {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      transition: opacity 0.3s ease;\n    }\n  }\n\n  // Shimmer overlay for loading state\n  .shimmerOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 50;\n    overflow: hidden;\n    pointer-events: none;\n    border-radius: 12px;\n  }\n\n  .shimmer {\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      90deg,\n      transparent 0%,\n      rgba(255, 255, 255, 0) 20%,\n      rgba(255, 255, 255, 0.5) 50%,\n      rgba(255, 255, 255, 0) 80%,\n      transparent 100%\n    );\n    animation: shimmerAnimation 0.75s infinite;\n  }\n\n  @keyframes shimmerAnimation {\n    0% {\n      left: -100%;\n    }\n    100% {\n      left: 100%;\n    }\n  }\n\n  // Timezone picker - positioned over FullCalendar's allDay slot\n  .timezonePicker {\n    position: absolute;\n    top: 140px; // Below toolbar, aligned with the all-day row\n    left: 22px;\n    z-index: 100;\n  }\n\n  .timezoneButton {\n    background: transparent;\n    border: none;\n    font-size: 12px;\n    font-weight: 500;\n    color: #6B7280;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: background-color 0.15s ease;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n  }\n\n}\n\n// Top-level so the same styles apply whether the dropdown is rendered inside\n// .oceanCalendarWrapper (week/day/month views) or portalled into document.body\n// (list view, to escape the cushion's overflow clipping).\n.timezoneDropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 4px;\n  background: white;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 160px;\n  max-height: 300px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.timezoneOption {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  background: none;\n  border: none;\n  text-align: left;\n  font-size: 13px;\n  color: #374151;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: #F3F4F6;\n  }\n\n  &.selected {\n    background-color: #EFF6FF;\n    color: #2563EB;\n    font-weight: 500;\n  }\n}\n\n// FullCalendar customization to match Ocean design\n:global(.fc) {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n\n  // Toolbar styling\n  :global(.fc-toolbar) {\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n    gap: 10px;\n\n    :global(.fc-toolbar-title) {\n      font-size: 20px;\n      font-weight: 600;\n      color: #111827;\n    }\n\n    :global(.fc-button-group) {\n      :global(.fc-button) {\n        background: #FFFFFF;\n        border: 1px solid #D1D5DB;\n        color: #374151;\n        padding: 6px 12px;\n        font-weight: 500;\n        font-size: 14px;\n        transition: all 0.2s;\n\n        &:hover:not(:disabled) {\n          background: #F3F4F6;\n          border-color: #9CA3AF;\n        }\n\n        &:focus {\n          box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n        }\n\n        &:global(.fc-button-active) {\n          background: #3B82F6;\n          color: white;\n          border-color: #3B82F6;\n\n          &:hover {\n            background: #2563EB;\n            border-color: #2563EB;\n          }\n        }\n\n        &:disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n      }\n    }\n\n    :global(.fc-today-button) {\n      background: #3B82F6;\n      color: white;\n      border: none;\n      padding: 6px 16px;\n      font-weight: 500;\n\n      &:hover:not(:disabled) {\n        background: #2563EB;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        background: #3B82F6;\n      }\n    }\n  }\n\n  // Calendar grid\n  :global(.fc-scrollgrid) {\n    border: 1px solid #E5E7EB;\n    border-radius: 8px;\n    overflow: visible; // Allow time indicator circle to extend beyond\n\n    // Override all border colors to be consistent\n    td, th {\n      border-color: #E5E7EB !important;\n    }\n  }\n\n  :global(.fc-scrollgrid-section-header) {\n    :global(.fc-col-header-cell) {\n      background: #F9FAFB;\n      padding: 10px 8px;\n      font-weight: 600;\n      color: #374151;\n      font-size: 13px;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      white-space: nowrap;\n      overflow: visible;\n    }\n  }\n\n  // All-day row styling - cut the divider line by 75%\n  :global(.fc-timegrid-divider) {\n    border-color: transparent !important; // Hide default divider\n    position: relative;\n\n    &::after {\n      content: '';\n      position: absolute;\n      left: 0;\n      right: 75% !important; // Cut line by 75%, only show 25%\n      top: 0;\n      height: 100%;\n      border-top: 1px solid #E5E7EB;\n    }\n  }\n\n  // Current time indicator styling\n  :global(.fc-timegrid-now-indicator-arrow) {\n    display: none; // Hide default triangle\n  }\n\n  :global(.fc-timegrid-now-indicator-line) {\n    border-color: #EF4444; // Red line color\n    border-width: 1px;\n    position: relative;\n    z-index: 100; // High z-index to appear above grid lines\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: -1px;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 0;\n      height: 0;\n      border-top: 6px solid transparent;\n      border-bottom: 6px solid transparent;\n      border-left: 8px solid #EF4444; // Arrow pointing right\n      z-index: 101; // Even higher to appear above everything\n    }\n  }\n\n  // Time grid styling\n  :global(.fc-timegrid) {\n    :global(.fc-timegrid-slot) {\n      height: 60px;\n      border-color: #E5E7EB !important; // Same grey for all lines\n\n      &:global(.fc-timegrid-slot-minor) {\n        border-top-style: solid !important; // Make half-hour lines solid\n        border-color: #E5E7EB !important; // Same grey as hour lines\n      }\n    }\n\n    :global(.fc-timegrid-slot-label) {\n      color: #6B7280;\n      font-size: 12px;\n      padding-right: 8px;\n      vertical-align: top !important; // Align time to the line like Google Calendar\n    }\n\n    // Position time label on the line itself, not between slots\n    :global(.fc-timegrid-axis-cushion) {\n      padding-top: 0 !important;\n      margin-top: -10px !important; // Pull up to sit on the line\n    }\n\n    :global(.fc-timegrid-axis-frame) {\n    border-top: 1px solid #E5E7EB; // Shortened line\n    //width: 72.5% !important;// Shortened line\n  }\n\n:global(.fc-timegrid-slot-lane) {\n    border-top: 1px solid #E5E7EB; \n    //width: 92.5% !important;// Shortened line\n    margin-top: -50px !important;\n    color: black !important;\n  }\n\n    // Only show labels on the hour, not half-hour\n    :global(.fc-timegrid-slot-minor .fc-timegrid-slot-label-frame) {\n      display: none;\n    }\n\n    // Hide 12am label only (keep 12pm visible)\n    :global(.fc-timegrid-slot-label-cushion) {\n      &:has-text(\"12 AM\") {\n        visibility: hidden;\n      }\n    }\n\n    // Alternative approach using data attribute matching - hide only 12am\n    :global(.fc-timegrid-slot[data-time=\"00:00:00\"] .fc-timegrid-slot-label-cushion) {\n      visibility: hidden;\n    }\n\n    :global(.fc-timegrid-axis) {\n      min-width: 80px !important;\n      padding: 0 8px;\n      z-index: 1 !important; // Keep time labels above today background\n      position: relative;\n\n      // Create shortened lines only in the time axis column\n      :global(.fc-timegrid-slot) {\n        border-top: none !important; // Hide default border in axis only\n      \n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        //left: -50px;\n        //width: 50px; // Show 50px of the line in the time column\n        height: 1px;\n        background-color: #E5E7EB;\n        z-index: 1;\n      }\n    }\n    }\n\n    // // Make all column borders the same\n    // :global(.fc-timegrid-cols) {\n    //   border-color: #000000 !important;\n    //   color: black !important;\n    //   width: 40% !important;// Shortened line\n    //   fill: black !important;\n    // }\n    // :global(.fc-timegrid-body) {\n    //   border-color: #000000 !important;\n    //   color: black !important;\n    //   width: 40% !important;// Shortened line\n    //   fill: black !important;\n    // }\n  }\n\n  :global(.fc-timegrid-axis) {\n        color: black !important;\n        //width: 40% !important;// Shortened line\n        margin-top: -50px !important;\n      }\n\n  // Fix timezone label cut-off in all-day slot\n  :global(.fc-timegrid-slot-label) {\n    white-space: nowrap !important;\n    overflow: visible !important;\n  }\n\n  :global(.fc-timegrid-axis-cushion),\n  :global(.fc-timegrid-slot-label-cushion) {\n    white-space: nowrap !important;\n    overflow: visible !important;\n    text-overflow: clip !important;\n  }\n\n  // Ensure the all-day row has enough height\n  :global(.fc-timegrid-divider) {\n    min-height: 30px !important;\n  }\n\n  // Day grid styling\n  :global(.fc-daygrid) {\n    :global(.fc-daygrid-day) {\n      &:global(.fc-day-today) {\n        background: #EFF6FF;\n      }\n\n      &:global(.fc-day-sat),\n      &:global(.fc-day-sun) {\n        background: #F9FAFB;\n      }\n    }\n\n    :global(.fc-daygrid-day-number) {\n      padding: 8px;\n      color: #374151;\n      font-weight: 500;\n    }\n\n    // Style the \"+x more\" link\n    :global(.fc-daygrid-more-link) {\n      color: #374151;\n      font-size: 13px;\n      font-weight: 500;\n      padding: 2px 4px;\n      margin: 2px 4px;\n\n      &:hover {\n        background: #F3F4F6;\n        border-radius: 4px;\n      }\n    }\n  }\n\n  // Event styling\n  :global(.fc-event) {\n    border: none;\n    border-radius: 6px;\n    padding: 4px 6px; // Normal padding for longer events\n    font-size: 13px;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;\n    overflow: hidden;\n    z-index: 10; // Above grid lines and today background\n\n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n      z-index: 20; // Even higher on hover\n    }\n\n    // Short events (< 30 min) - zero top padding to fit title\n    &:global(.short-event) {\n      padding: 0px 3px;\n\n      :global(.fc-event-main) {\n        padding: 0 2px;\n      }\n    }\n\n    // Time grid events - ensure content fits\n    &:global(.fc-timegrid-event) {\n      :global(.fc-event-main) {\n        display: flex;\n        align-items: flex-start; // Align content to top\n      }\n    }\n\n    // Style for completed assignments\n    &:global(.completed-assignment) {\n      opacity: 0.25 !important; // Very transparent to show calendar background\n    }\n\n    // Style for AI suggested events\n    &:global(.suggested-event) {\n      border: 2px dashed currentColor !important;\n      // Don't override background - let backend's lighter course color show through\n      // Note: position must stay 'absolute' (FC's default) so the event fills its\n      // harness correctly. The shimmer lives on .fc-event-main instead.\n\n      // Shimmer effect (grid/day/month views) — scoped to the inner content div\n      // so we don't override FC's position:absolute on the event element itself.\n      :global(.fc-event-main) {\n        position: relative;\n        overflow: hidden;\n\n        &::after {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: -100%;\n          width: 100%;\n          height: 100%;\n          background: linear-gradient(\n            90deg,\n            transparent,\n            rgba(255, 255, 255, 0.4),\n            transparent\n          );\n          animation: shimmer 2s infinite;\n        }\n      }\n    }\n  }\n\n  // List view: <tr> doesn't support overflow:hidden or position:relative, so the\n  // shimmer escapes the row. Suppress it on the <tr> and re-apply it scoped to\n  // the title cell, which is a normal <td> that clips correctly.\n  :global(.fc-list-table .suggested-event) {\n    &::after {\n      display: none;\n    }\n\n    :global(.fc-list-event-title) {\n      position: relative;\n      overflow: hidden;\n      z-index: 0; // Keep this positioned cell below the sticky day header\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: -100%;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(\n          90deg,\n          transparent,\n          rgba(255, 255, 255, 0.4),\n          transparent\n        );\n        animation: shimmer 2s infinite;\n      }\n    }\n  }\n\n  @keyframes shimmer {\n    0% {\n      left: -100%;\n    }\n    100% {\n      left: 100%;\n    }\n  }\n\n  // Today highlight\n  :global(.fc-day-today) {\n    background: #EFF6FF !important;\n    z-index: 0 !important; // Lower than grid lines so grid shows on top\n\n    :global(.fc-daygrid-day-number) {\n      background: #3B82F6;\n      color: white;\n      border-radius: 50%;\n      width: 28px;\n      height: 28px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin: 4px;\n      position: relative;\n      z-index: 2; // Keep day number above grid\n    }\n  }\n\n  // List view styling\n  :global(.fc-list) {\n    border: none;\n\n    :global(.fc-list-day) {\n      background: #F9FAFB;\n      font-weight: 600;\n      color: #111827;\n\n      // FC paints the sticky <th> white (var(--fc-page-bg-color)) and the\n      // cushion semi-transparent (var(--fc-neutral-bg-color) = hsla 0.3a).\n      // Force both to solid grey so the row reads as one continuous block\n      // and doesn't blend into the white event rows below. The high z-index\n      // is needed because suggested-event title cells have position:relative\n      // (from the shimmer containment fix), which can otherwise stack above\n      // the sticky <th> during scroll.\n      > * {\n        background: #F3F4F6 !important;\n        z-index: 200 !important; // Must beat .taskCheckbox (z-index:100) so completion circles don't show through\n      }\n\n      :global(.fc-list-day-cushion) {\n        background: #F3F4F6 !important;\n      }\n\n      // Only show the TZ button in the cushion that is currently the\n      // topmost sticky one (class toggled by a scroll listener in JS).\n      :global(.ocean-tz-portal) {\n        display: none;\n      }\n      :global(.fc-list-day-cushion.ocean-tz-topmost) :global(.ocean-tz-portal) {\n        display: inline-flex;\n      }\n    }\n\n    :global(.fc-list-event) {\n      cursor: pointer;\n\n      &:hover {\n        background: #F3F4F6;\n      }\n\n      :global(.fc-list-event-dot) {\n        border-radius: 2px;\n        width: 10px;\n        height: 10px;\n      }\n\n      :global(.fc-list-event-title) {\n        color: #111827;\n      }\n\n      :global(.fc-list-event-time) {\n        color: #6B7280;\n      }\n    }\n  }\n}\n\n// Custom event content styling\n.customEventContent {\n  position: relative;\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  height: 100%;\n  padding-top: 0; // Ensure no extra top padding\n\n  // Completed task styling - strikethrough only (opacity handled by fc-event)\n  &.completedTask {\n    .eventTitle {\n      text-decoration: line-through;\n    }\n  }\n\n  // Checkbox styling for tasks\n  .taskCheckbox {\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 2px solid rgba(255, 255, 255, 0.8);\n    background: transparent;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    padding: 0;\n    margin-top: 2px;\n    z-index: 100;\n\n    &:hover {\n      border-color: rgba(255, 255, 255, 1);\n      background: rgba(255, 255, 255, 0.1);\n      transform: scale(1.1);\n    }\n\n    &:active {\n      transform: scale(0.95);\n    }\n\n    &.checked {\n      border-color: transparent;\n      background: transparent;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.1);\n      }\n    }\n\n    .checkIcon {\n      width: 18px;\n      height: 18px;\n      color: rgba(255, 255, 255, 0.9);\n      stroke-width: 2.5;\n    }\n  }\n\n  // Keep checkbox visible even when parent event is very transparent\n  :global(.fc-event.completed-assignment) {\n    .taskCheckbox {\n      opacity: 1; // Override parent opacity for checkbox visibility\n    }\n  }\n\n  .eventDetails {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  &.monthView {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n\n    .eventTime {\n      font-size: 12px;\n      font-weight: 600;\n      flex-shrink: 0;\n    }\n\n    .eventCourse {\n      font-size: 12px;\n      font-weight: 500;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .eventTime {\n    font-size: 11px;\n    opacity: 0.8;\n    margin-bottom: 2px;\n  }\n\n  .eventTitle {\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 1.1; // Tighter line-height for short events\n    transition: text-decoration 0.2s ease;\n    margin-top: 0; // Ensure title starts at top\n  }\n\n  .eventLocation {\n    font-size: 11px;\n    opacity: 0.7;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    .locationIcon {\n      width: 10px;\n      height: 10px;\n      flex-shrink: 0;\n    }\n  }\n\n  .eventGrade {\n    font-size: 11px;\n    font-weight: 600;\n    margin-top: 2px;\n    opacity: 0.9;\n  }\n}\n\n// In list view events have a white background, so the white checkbox border\n// is invisible. This rule must be top-level so \".fc-list .taskCheckbox_hash\"\n// compiles correctly (fc-list is an ancestor, not a descendant, of the content).\n:global(.fc-list) {\n  .taskCheckbox {\n    border-color: #D1D5DB;\n\n    &:hover {\n      border-color: #9CA3AF;\n      background: rgba(0, 0, 0, 0.05);\n    }\n\n    &.checked {\n      border-color: transparent;\n    }\n\n    .checkIcon {\n      color: #374151;\n    }\n  }\n}\n\n// Event Popover Styling\n.eventPopover {\n  position: fixed;\n  background: white;\n  border-radius: 12px;\n  border: 3px solid; // Border color set via inline style\n  width: 500px;\n  max-height: 80vh;\n  overflow: visible;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15),\n              0 3px 6px rgba(0, 0, 0, 0.1);\n  z-index: 9999;\n  animation: popIn 0.15s ease-out;\n\n  // Mobile: center the card and reduce width\n  @media (max-width: 767px) {\n    width: calc(100vw - 32px);\n    max-width: 350px;\n    left: 50% !important;\n    transform: translateX(-50%);\n    top: 175px !important;\n  }\n\n  .modalHeader {\n    padding: 20px 20px 12px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n\n    h2 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      color: #111827;\n      line-height: 1.3;\n      flex: 1;\n      padding-right: 10px;\n    }\n\n    .headerActions {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n    }\n\n    .iconBtn {\n      background: none;\n      border: none;\n      padding: 6px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 6px;\n      transition: all 0.2s;\n\n      &:hover {\n        background: #F3F4F6;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n\n      .actionIcon {\n        width: 18px;\n        height: 18px;\n        color: #6B7280;\n      }\n\n      &.deleteBtn {\n        .actionIcon {\n          // Make white SVG appear dark using filter\n          filter: invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(60%) contrast(90%);\n        }\n\n        &:hover {\n          background: #FEE2E2;\n\n          .actionIcon {\n            filter: invert(22%) sepia(90%) saturate(2000%) hue-rotate(346deg) brightness(90%) contrast(95%);\n          }\n        }\n      }\n    }\n\n    .closeBtn {\n      background: none;\n      border: none;\n      font-size: 24px;\n      color: #6B7280;\n      cursor: pointer;\n      padding: 0;\n      width: 28px;\n      height: 28px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 4px;\n      transition: all 0.2s;\n      flex-shrink: 0;\n\n      &:hover {\n        background: #F3F4F6;\n        color: #111827;\n      }\n    }\n  }\n\n  .modalDateTime {\n    padding: 0 20px 16px 20px;\n    font-size: 14px;\n\n    .dateText {\n      color: #374151;\n      font-weight: 500;\n    }\n  }\n\n  .modalDivider {\n    height: 1px;\n    background: #E5E7EB;\n    margin: 0 20px 16px 20px;\n  }\n\n  .modalBody {\n    padding: 0 20px 20px 20px;\n\n    .locationRow {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 12px;\n      color: #374151;\n      font-size: 14px;\n\n      .locationIconModal {\n        width: 16px;\n        height: 16px;\n        flex-shrink: 0;\n        color: #6B7280;\n      }\n    }\n\n    .description {\n      color: #4B5563;\n      font-size: 14px;\n      line-height: 1.5;\n      margin: 0;\n    }\n\n    .aiReasoning {\n      margin-top: 16px;\n      padding: 12px;\n      background: #EFF6FF;\n      border-radius: 8px;\n      border: 1px solid #BFDBFE;\n\n      .reasoningLabel {\n        font-size: 12px;\n        font-weight: 600;\n        color: #2563EB;\n        text-transform: uppercase;\n        letter-spacing: 0.05em;\n      }\n\n      p {\n        margin: 8px 0 0 0;\n        font-size: 13px;\n        color: #1D4ED8;\n        line-height: 1.4;\n      }\n\n      .userSelectedTime {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 13px;\n        color: #2563EB;\n        font-weight: 500;\n      }\n\n      .infoIcon {\n        width: 16px;\n        height: 16px;\n        flex-shrink: 0;\n      }\n    }\n\n    .suggestionActions {\n      display: flex;\n      gap: 12px;\n      margin-top: 20px;\n      padding-top: 16px;\n      border-top: 1px solid #E5E7EB;\n    }\n\n    .dismissBtn {\n      flex: 1;\n      padding: 10px 16px;\n      border: 1px solid #E5E7EB;\n      border-radius: 8px;\n      background: white;\n      color: #374151;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &:hover {\n        background: #F9FAFB;\n        border-color: #D1D5DB;\n      }\n    }\n\n    .acceptBtn {\n      flex: 1;\n      padding: 10px 16px;\n      border: none;\n      border-radius: 8px;\n      background: #3B82F6;\n      color: white;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &:hover {\n        background: #2563EB;\n      }\n    }\n  }\n\n  .suggestionBadge {\n    margin: 0 20px 12px 20px;\n    padding: 4px 10px;\n    background: linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%);\n    color: white;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    border-radius: 4px;\n    display: inline-block;\n  }\n\n  .importSourceRow {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 0 20px 12px 20px;\n    font-size: 11px;\n    color: #666;\n\n    .infoIcon {\n      width: 13px;\n      height: 13px;\n      flex-shrink: 0;\n      color: #666;\n    }\n\n    .importSourceText {\n      line-height: 1.4;\n    }\n  }\n\n  // Edit form styles\n  .editForm {\n    padding: 0 20px 20px 20px;\n\n    .formGroup {\n      margin-bottom: 16px;\n\n      label {\n        display: block;\n        font-size: 13px;\n        font-weight: 500;\n        color: #374151;\n        margin-bottom: 6px;\n      }\n\n      input,\n      textarea {\n        width: 100%;\n        padding: 10px 12px;\n        border: 1.5px solid #E5E7EB;\n        border-radius: 8px;\n        font-size: 14px;\n        color: #111827;\n        background: white;\n        transition: all 0.2s;\n        font-family: inherit;\n\n        &:focus {\n          outline: none;\n          border-color: #3B82F6;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n\n        &::placeholder {\n          color: #9CA3AF;\n        }\n      }\n\n      textarea {\n        resize: vertical;\n        min-height: 80px;\n      }\n    }\n\n    .formRow {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 12px;\n\n      // Stack vertically on mobile\n      @media (max-width: 767px) {\n        grid-template-columns: 1fr;\n      }\n\n      .formGroup {\n        margin-bottom: 16px;\n      }\n    }\n\n    .datePicker {\n      width: 100%;\n      min-width: 180px;\n      padding: 10px 12px;\n      border: 1.5px solid #E5E7EB;\n      border-radius: 8px;\n      font-size: 14px;\n      color: #111827;\n      background: white;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &:focus {\n        outline: none;\n        border-color: #3B82F6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n    }\n\n    .courseSelect {\n      width: 100%;\n      padding: 10px 12px;\n      border: 1.5px solid #E5E7EB;\n      border-radius: 8px;\n      font-size: 14px;\n      color: #111827;\n      background: white;\n      cursor: pointer;\n      transition: all 0.2s;\n      appearance: none;\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B7280' d='M2 4l4 4 4-4'/%3E%3C/svg%3E\");\n      background-repeat: no-repeat;\n      background-position: right 12px center;\n      padding-right: 36px;\n\n      &:focus {\n        outline: none;\n        border-color: #3B82F6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n    }\n\n    .formActions {\n      display: flex;\n      justify-content: flex-end;\n      gap: 10px;\n      margin-top: 20px;\n\n      .cancelBtn,\n      .saveBtn {\n        padding: 10px 20px;\n        border-radius: 8px;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s;\n        border: none;\n\n        &:disabled {\n          opacity: 0.6;\n          cursor: not-allowed;\n        }\n      }\n\n      .cancelBtn {\n        background: #F3F4F6;\n        color: #374151;\n\n        &:hover:not(:disabled) {\n          background: #E5E7EB;\n        }\n      }\n\n      .saveBtn {\n        background: #3B82F6;\n        color: white;\n\n        &:hover:not(:disabled) {\n          background: #2563EB;\n        }\n      }\n    }\n  }\n}\n\n// React DatePicker custom styles - circular day selection\n:global(.react-datepicker) {\n  font-family: inherit;\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n:global(.react-datepicker__header) {\n  background: #F9FAFB;\n  border-bottom: 1px solid #E5E7EB;\n  border-radius: 12px 12px 0 0;\n  padding-top: 12px;\n}\n\n:global(.react-datepicker__current-month) {\n  font-weight: 600;\n  font-size: 14px;\n  color: #111827;\n}\n\n:global(.react-datepicker__day-name) {\n  color: #6B7280;\n  font-weight: 500;\n  font-size: 12px;\n  width: 32px;\n  line-height: 32px;\n}\n\n:global(.react-datepicker__day) {\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  border-radius: 50%;\n  color: #374151;\n  font-size: 13px;\n  transition: all 0.15s;\n\n  &:hover {\n    background: #F3F4F6;\n    border-radius: 50%;\n  }\n}\n\n:global(.react-datepicker__day--selected),\n:global(.react-datepicker__day--keyboard-selected) {\n  background: #3B82F6 !important;\n  color: white !important;\n  border-radius: 50% !important;\n  font-weight: 500;\n\n  &:hover {\n    background: #2563EB !important;\n    border-radius: 50% !important;\n  }\n}\n\n:global(.react-datepicker__day--today) {\n  font-weight: 600;\n  color: #3B82F6;\n\n  &:not(.react-datepicker__day--selected) {\n    background: transparent;\n  }\n}\n\n:global(.react-datepicker__day--outside-month) {\n  color: #D1D5DB;\n}\n\n:global(.react-datepicker__navigation) {\n  top: 12px;\n}\n\n:global(.react-datepicker__navigation-icon::before) {\n  border-color: #6B7280;\n}\n\n:global(.react-datepicker__time-container) {\n  border-left: 1px solid #E5E7EB;\n}\n\n:global(.react-datepicker__time-list-item) {\n  font-size: 13px;\n  padding: 8px 12px !important;\n\n  &:hover {\n    background: #F3F4F6 !important;\n  }\n}\n\n:global(.react-datepicker__time-list-item--selected) {\n  background: #3B82F6 !important;\n  color: white !important;\n  font-weight: 500;\n}\n\n:global(.react-datepicker-popper) {\n  z-index: 10000 !important;\n  margin-left: 50px !important;\n\n  // Mobile: position datepicker to fit screen\n  @media (max-width: 767px) {\n    margin-left: 0 !important;\n    left: 50% !important;\n    transform: translateX(-50%) !important;\n  }\n}\n\n// Mobile: make datepicker wider to fit calendar + time\n@media (max-width: 767px) {\n  :global(.react-datepicker) {\n    min-width: 340px;\n  }\n\n  :global(.react-datepicker__month-container) {\n    width: 250px;\n  }\n\n  :global(.react-datepicker__time-container) {\n    width: 85px;\n  }\n}\n\n// Undo Delete Toast\n.undoToast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: white;\n  padding: 12px 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  z-index: 10001;\n  animation: slideUp 0.2s ease-out;\n\n  span {\n    font-size: 14px;\n    color: #374151;\n  }\n\n  .undoButton {\n    background: #3B82F6;\n    color: white;\n    border: none;\n    padding: 6px 14px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background 0.2s;\n\n    &:hover {\n      background: #2563EB;\n    }\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n// Animations\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes popIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  :global(.fc) {\n    :global(.fc-toolbar) {\n      flex-direction: column;\n\n      :global(.fc-toolbar-chunk) {\n        display: flex;\n        justify-content: center;\n        margin: 5px 0;\n        width: 100%;\n      }\n\n      :global(.fc-toolbar-title) {\n        font-size: 18px;\n      }\n    }\n\n    :global(.fc-event) {\n      .customEventContent {\n        .eventLocation,\n        .eventGrade {\n          display: none; // Hide on mobile for cleaner view\n        }\n\n        .taskCheckbox {\n          width: 24px;\n          height: 24px;\n          border-width: 2.5px;\n\n          .checkIcon {\n            width: 20px;\n            height: 20px;\n          }\n        }\n      }\n    }\n\n    // Week/Day view: hide time, show title wrapped to fill event height\n    :global(.fc-timegrid-event) {\n      .customEventContent {\n        height: 100%;\n\n        .eventTime {\n          display: none;\n        }\n        .eventTitle {\n          white-space: normal;\n          word-wrap: break-word;\n          overflow-wrap: break-word;\n          overflow: hidden;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          -webkit-line-clamp: unset;\n        }\n      }\n    }\n\n    // Month view: hide time, only show title (truncated)\n    :global(.fc-daygrid-event) {\n      .customEventContent.monthView {\n        .eventTime {\n          display: none;\n        }\n        .eventCourse {\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n\n    // List view: constrain width and wrap text\n    :global(.fc-list) {\n      width: 100% !important;\n      max-width: 100% !important;\n      overflow-x: hidden !important;\n\n      :global(.fc-list-table) {\n        width: 100% !important;\n        table-layout: fixed !important;\n      }\n\n      // Hide the date column on mobile to save space\n      :global(.fc-list-day-cushion) {\n        padding: 8px 12px !important;\n\n        :global(.fc-list-day-text),\n        :global(.fc-list-day-side-text) {\n          font-size: 13px;\n        }\n      }\n\n      :global(.fc-list-event-time) {\n        font-size: 12px !important;\n        padding: 8px 4px 8px 12px !important;\n        width: 90px !important;\n      }\n\n      :global(.fc-list-event-graphic) {\n        padding: 8px 4px !important;\n        width: 20px !important;\n      }\n\n      :global(.fc-list-event-title) {\n        white-space: normal !important;\n        word-wrap: break-word !important;\n        overflow-wrap: break-word !important;\n        padding: 8px 12px 8px 4px !important;\n        font-size: 13px !important;\n      }\n    }\n  }\n}\n\n// Mobile Calendar Header\n.mobileCalendarHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: white;\n  border-bottom: 1px solid #E5E7EB;\n  position: relative;\n  z-index: 101;\n\n  @media (max-width: 375px) {\n    padding: 12px 16px; // Reduce padding on very small screens\n  }\n\n  .mobileHeaderLeft {\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex-shrink: 0; // Prevent hamburger from shrinking\n  }\n\n  .hamburgerButton {\n    background: none;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #374151;\n    transition: background 0.2s;\n    border-radius: 6px;\n\n    &:hover {\n      background: #F3F4F6;\n    }\n\n    &:active {\n      background: #E5E7EB;\n    }\n  }\n\n  .mobileViewDropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    background: white;\n    border: 1px solid #E5E7EB;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    min-width: 150px;\n    overflow: hidden;\n    z-index: 1000;\n    animation: slideDown 0.2s ease-out;\n  }\n\n  .mobileViewOption {\n    display: block;\n    width: 100%;\n    padding: 12px 16px;\n    background: none;\n    border: none;\n    text-align: left;\n    font-size: 15px;\n    color: #374151;\n    cursor: pointer;\n    transition: background 0.2s;\n    font-weight: 400;\n\n    &:hover {\n      background: #F3F4F6;\n    }\n\n    &.active {\n      color: #3B82F6;\n      font-weight: 600;\n      background: #EFF6FF;\n    }\n\n    &:not(:last-child) {\n      border-bottom: 1px solid #F3F4F6;\n    }\n  }\n\n  .dropdownSeparator {\n    height: 1px;\n    background: #E5E7EB;\n    margin: 4px 0;\n  }\n\n  .syncOption {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .optionIcon {\n      width: 18px;\n      height: 18px;\n      flex-shrink: 0;\n\n      svg {\n        width: 100%;\n        height: 100%;\n      }\n    }\n\n    &.connected {\n      color: #3B82F6;\n\n      .optionIcon svg {\n        fill: #3B82F6;\n      }\n    }\n\n    .statusIndicator {\n      margin-left: auto;\n      color: #3B82F6;\n      font-size: 20px;\n      line-height: 1;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  .mobileHeaderCenter {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    padding: 0 16px;\n    min-width: 0; // Allow flex item to shrink below content size\n\n    @media (max-width: 375px) {\n      padding: 0 8px; // Reduce padding on very small screens\n    }\n  }\n\n  .mobileTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #111827;\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%; // Ensure title can shrink within container\n\n    @media (max-width: 375px) {\n      font-size: 16px;\n    }\n  }\n\n  .mobileHeaderRight {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0; // Prevent buttons from shrinking\n\n    @media (max-width: 375px) {\n      gap: 4px; // Reduce gap on very small screens\n    }\n  }\n\n  .navArrowButton {\n    background: none;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #374151;\n    transition: background 0.2s;\n    border-radius: 6px;\n\n    &:hover {\n      background: #F3F4F6;\n    }\n\n    &:active {\n      background: #E5E7EB;\n    }\n  }\n\n  .chatbotButton {\n    background: none;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #374151;\n    transition: background 0.2s, transform 0.2s;\n    border-radius: 6px;\n    margin-left: 4px;\n\n    &:hover {\n      background: #F3F4F6;\n      transform: translateY(-1px);\n    }\n\n    &:active {\n      background: #E5E7EB;\n      transform: translateY(0);\n    }\n  }\n\n  .oceanLogo {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n  }\n}\n\n// Dropdown slide animation\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Hide desktop toolbar elements on mobile - replaced by custom mobile header\n@media (max-width: 768px) {\n  .syncToolbarElement {\n    display: none;\n  }\n\n  .inlineToolbarElements {\n    display: none; // Hides Calendar dropdown and chatbot button - replaced by mobile header\n  }\n}\n\n\n/* --- MOBILE SPECIFIC STYLES --- */\n@media (max-width: 768px) {\n  \n  /* 1. HIDE DESKTOP ELEMENTS (Critical for your previous request) */\n  .syncToolbarElement,\n  .inlineToolbarElements,\n  :global(.fc-header-toolbar) {\n    display: none !important;\n  }\n\n  /* 2. FIX HEADER OVERFLOW (The \"No Overflow\" Fix) */\n  :global(.fc) {\n    /* Target the container of the date text */\n    :global(.fc-col-header-cell) {\n      padding: 0 !important;        /* Zero padding around the cell */\n      vertical-align: middle;\n    }\n\n    /* Target the text itself (e.g., \"Sun 12\") */\n    :global(.fc-col-header-cell-cushion) {\n      /* Dynamic Font Size:\n         - Minimum: 9px (so it's never unreadable)\n         - Preferred: 3.5% of viewport width (scales with phone width)\n         - Maximum: 12px (caps it so it doesn't get huge on tablets) \n      */\n      font-size: clamp(9px, 3.5vw, 12px) !important;\n      \n      /* Squeeze spacing */\n      letter-spacing: -0.5px !important; \n      padding: 4px 0 !important;    /* Top/bottom padding only */\n      width: 100%;                  /* Force it to fill the cell */\n      display: block !important;    /* Helps centering */\n    }\n  }\n\n  /* ... Your other mobile tweaks (like the event styles) go here ... */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"oceanCalendarWrapper": `styles_oceanCalendarWrapper__sqXp8`,
	"syncToolbarElement": `styles_syncToolbarElement__O+Y94`,
	"chatbotOpen": `styles_chatbotOpen__+oAm9`,
	"chatbotClosed": `styles_chatbotClosed__2f+6C`,
	"inlineToolbarElements": `styles_inlineToolbarElements__cDCs-`,
	"navDropdownContainer": `styles_navDropdownContainer__GG1bn`,
	"navDropdownButton": `styles_navDropdownButton__BJdwe`,
	"dropdownArrow": `styles_dropdownArrow__bfZ3F`,
	"open": `styles_open__5X1Ud`,
	"navDropdownMenu": `styles_navDropdownMenu__U1h9q`,
	"navDropdownItem": `styles_navDropdownItem__hyycS`,
	"active": `styles_active__xyHD0`,
	"chatbotToggle": `styles_chatbotToggle__xQPzy`,
	"calendarContainer": `styles_calendarContainer__+eH4A`,
	"isLoading": `styles_isLoading__zEyNn`,
	"shimmerOverlay": `styles_shimmerOverlay__yqqtb`,
	"shimmer": `styles_shimmer__GLFda`,
	"shimmerAnimation": `styles_shimmerAnimation__PRgc0`,
	"timezonePicker": `styles_timezonePicker__Z061v`,
	"timezoneButton": `styles_timezoneButton__IO9KK`,
	"timezoneDropdown": `styles_timezoneDropdown__mpbMj`,
	"timezoneOption": `styles_timezoneOption__Iu75U`,
	"selected": `styles_selected__R3WqA`,
	"customEventContent": `styles_customEventContent__fmmbU`,
	"completedTask": `styles_completedTask__Yq3Dd`,
	"eventTitle": `styles_eventTitle__N6tPw`,
	"taskCheckbox": `styles_taskCheckbox__K4JB9`,
	"checked": `styles_checked__QEoWK`,
	"checkIcon": `styles_checkIcon__u+jwx`,
	"eventDetails": `styles_eventDetails__+rsOz`,
	"monthView": `styles_monthView__31fp3`,
	"eventTime": `styles_eventTime__N8Zca`,
	"eventCourse": `styles_eventCourse__xbqhF`,
	"eventLocation": `styles_eventLocation__xRGS9`,
	"locationIcon": `styles_locationIcon__zIl9g`,
	"eventGrade": `styles_eventGrade__lgc0+`,
	"eventPopover": `styles_eventPopover__wz4G6`,
	"popIn": `styles_popIn__dm3hq`,
	"modalHeader": `styles_modalHeader__ripPC`,
	"headerActions": `styles_headerActions__AbAxc`,
	"iconBtn": `styles_iconBtn__zsKBH`,
	"actionIcon": `styles_actionIcon__nPjAW`,
	"deleteBtn": `styles_deleteBtn__q8P0M`,
	"closeBtn": `styles_closeBtn__41Fhf`,
	"modalDateTime": `styles_modalDateTime__4WiNM`,
	"dateText": `styles_dateText__ficBH`,
	"modalDivider": `styles_modalDivider__8gAls`,
	"modalBody": `styles_modalBody__eOh8W`,
	"locationRow": `styles_locationRow__h7+6M`,
	"locationIconModal": `styles_locationIconModal__WLfAw`,
	"description": `styles_description__h6KxA`,
	"aiReasoning": `styles_aiReasoning__m0-0U`,
	"reasoningLabel": `styles_reasoningLabel__p+vIx`,
	"userSelectedTime": `styles_userSelectedTime__oLA88`,
	"infoIcon": `styles_infoIcon__2Zhjl`,
	"suggestionActions": `styles_suggestionActions__6w2up`,
	"dismissBtn": `styles_dismissBtn__TST9K`,
	"acceptBtn": `styles_acceptBtn__om0bL`,
	"suggestionBadge": `styles_suggestionBadge__g5Ao9`,
	"importSourceRow": `styles_importSourceRow__6wz1H`,
	"importSourceText": `styles_importSourceText__5Zek6`,
	"editForm": `styles_editForm__4R4v+`,
	"formGroup": `styles_formGroup__ionGn`,
	"formRow": `styles_formRow__Uf4Pd`,
	"datePicker": `styles_datePicker__wcCtr`,
	"courseSelect": `styles_courseSelect__UO9Jf`,
	"formActions": `styles_formActions__ndExz`,
	"cancelBtn": `styles_cancelBtn__1hleq`,
	"saveBtn": `styles_saveBtn__B2g7B`,
	"react-datepicker__day--selected": `styles_react-datepicker__day--selected__P6WUq`,
	"undoToast": `styles_undoToast__o5X86`,
	"slideUp": `styles_slideUp__YZMKK`,
	"undoButton": `styles_undoButton__ARIXa`,
	"mobileCalendarHeader": `styles_mobileCalendarHeader__W09Rk`,
	"mobileHeaderLeft": `styles_mobileHeaderLeft__vWO2N`,
	"hamburgerButton": `styles_hamburgerButton__aliBF`,
	"mobileViewDropdown": `styles_mobileViewDropdown__+IS1-`,
	"slideDown": `styles_slideDown__uB0Gf`,
	"mobileViewOption": `styles_mobileViewOption__bQQsn`,
	"dropdownSeparator": `styles_dropdownSeparator__RFYB7`,
	"syncOption": `styles_syncOption__To+3l`,
	"optionIcon": `styles_optionIcon__loU3n`,
	"connected": `styles_connected__xU-B0`,
	"statusIndicator": `styles_statusIndicator__LAoWi`,
	"mobileHeaderCenter": `styles_mobileHeaderCenter__hJSej`,
	"mobileTitle": `styles_mobileTitle__5W9pE`,
	"mobileHeaderRight": `styles_mobileHeaderRight__8VIYF`,
	"navArrowButton": `styles_navArrowButton__UmK0F`,
	"chatbotButton": `styles_chatbotButton__g4Dtc`,
	"oceanLogo": `styles_oceanLogo__4Xqmu`,
	"fadeIn": `styles_fadeIn__MTauJ`
};
export default ___CSS_LOADER_EXPORT___;
